import { compose } from "redux";
import times from "lodash/times";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Grid, withStyles } from "@material-ui/core";

import { addViewGroupColumn } from "features/planner/planner.actions";
import ViewGroupColumn from "features/planner/components/View/ViewGroupColumn";
import GroupsContainerHeader from "features/planner/components/View/GroupsContainerHeader";

class GroupsContainer extends PureComponent {
  addViewGroupColumn = () => {
    const {
      type,
      viewId,
      saveViewGroupOrder,
      dispatchAddViewGroupColumn,
    } = this.props;

    dispatchAddViewGroupColumn(viewId, type, saveViewGroupOrder);
  };

  deleteViewGroupColumn = () => {
    const { type, columnCount, deleteViewGroupColumn } = this.props;

    deleteViewGroupColumn(
      type,
      columnCount - 1, // delete last column
    );
  };

  render() {
    const {
      type,
      viewId,
      classes,
      isEditMode,
      columnCount,
      saveViewGroupOrder,
      deleteViewGroupColumn,
    } = this.props;

    return (
      <Grid item className={classes.root}>
        {isEditMode && (
          <GroupsContainerHeader
            type={type}
            columnCount={columnCount}
            addViewGroupColumn={this.addViewGroupColumn}
            deleteViewGroupColumn={this.deleteViewGroupColumn}
          />
        )}
        <Grid item xs container wrap="nowrap" className={classes.content}>
          {times(columnCount, column => (
            <ViewGroupColumn
              type={type}
              key={column}
              viewId={viewId}
              column={column}
              isEditMode={isEditMode}
              saveViewGroupOrder={saveViewGroupOrder}
              deleteViewGroupColumn={deleteViewGroupColumn}
            />
          ))}
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    display: "flex",
    overflow: "hidden",
    flexDirection: "column",
    paddingTop: theme.spacing(1),
  },
  content: {
    overflow: "auto",
  },
});

export default compose(
  connect(null, {
    dispatchAddViewGroupColumn: addViewGroupColumn,
  }),
  withStyles(styles),
)(GroupsContainer);
